import { ShipmentClient } from "./clients";

const trazabilidadPath = "trazabilidad";

export default {
  getShipment(id) {
    return ShipmentClient.get(`${trazabilidadPath}/dataShipments/${id}?user=1&lang=EN`);
  },
  getEvents(id) {
    return ShipmentClient.get(`${trazabilidadPath}/shipmentevents/${id}?lang=EN`);
  },
};
